// Polyfill process for browser compatibility with libraries that expect Node.js environment
if (typeof window !== 'undefined' && !window.process) {
  window.process = {
    env: {},
    browser: true,
    version: '',
    versions: {},
    nextTick: (fn, ...args) => setTimeout(() => fn(...args), 0),
    cwd: () => '/',
    platform: 'browser'
  };
}

import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(<App />);
